export const versionNumber = '8c674e4'
